export { default } from './SpotClusterMarker';
